import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AdditionalToppingsPage } from './additional-toppings.page';

const routes: Routes = [
  {
    path: '',
    component: AdditionalToppingsPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AdditionalToppingsPageRoutingModule {}
